import api from '@/api/index.js'

const distributor_clients = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_DISTRIBUTOR_CLIENTS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_DISTRIBUTOR_CLIENT_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_DISTRIBUTOR_CLIENT_UPDATED: (state, updated) => {
      if (state.data) {
        state.data = state.data.filter(item => {
          if (item.id == updated.id) {
            item.system_account_id = updated.system_account_id;
            item.name = updated.name;
            item.modified_by = updated.modified_by;
            item.updated_at = updated.updated_at;
          }
          return item
        });
      }
      state.updating = false;
    },
    SET_DISTRIBUTOR_CLIENTS: (state, teams) => {
      state.data = teams
      state.loading = false;
    },
    SET_DISTRIBUTOR_CLIENTS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadDistributorClients({commit}, id) {
      commit('SET_DISTRIBUTOR_CLIENTS_LOADING', true)
      commit('SET_DISTRIBUTOR_CLIENTS_ERROR', null)
      return api.get(`distributors/${id}/clients`)
        .then((response) => {
          commit('SET_DISTRIBUTOR_CLIENTS', response)
        })
        .catch((error) => {
          commit('SET_DISTRIBUTOR_CLIENTS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISTRIBUTOR_CLIENTS_LOADING', false)
        })
    },
    UpdateDistributorClient({commit}, req) {
      commit('SET_DISTRIBUTOR_CLIENT_UPDATING', true);
      commit('SET_DISTRIBUTOR_CLIENTS_ERROR', null)
      return api.put(`distributors/${req.distributor_id}/clients/${req.distributor_client_id}`, req.payload)
        .then((response) => {
          commit('SET_DISTRIBUTOR_CLIENT_UPDATED', response.body);
        })
        .catch((error) => {
          commit('SET_DISTRIBUTOR_CLIENTS_ERROR', error)
          commit('SET_DISTRIBUTOR_CLIENT_UPDATING', false);
        })
    }
  }
}

export default distributor_clients
